import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface NumberSequenceResetDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  moduleName?: string;
  onConfirm: () => void;
}

export function NumberSequenceResetDialog({
  isOpen,
  onOpenChange,
  moduleName,
  onConfirm,
}: NumberSequenceResetDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Reset Counter Nomor Urut?</DialogTitle>
          <DialogDescription className="text-xs text-muted-foreground pt-1">
            Counter nomor urut untuk modul{" "}
            <strong className="text-foreground">{moduleName}</strong> akan
            dikembalikan ke <strong>1</strong>. Transaksi berikutnya akan mulai
            menghitung kembali dari angka 1.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="gap-2 pt-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onOpenChange(false)}
          >
            Batal
          </Button>
          <Button
            type="button"
            variant="destructive"
            size="sm"
            onClick={onConfirm}
          >
            Ya, Reset ke 1
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
